export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 via-cyan-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/6fe7b7b2593b9ff0ac39009a064f5982/646b197efc9d95407747f5ac32aea80e.png"
              alt="Company Logo"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-teal-50 text-sm leading-relaxed mb-6">
              Empowering enterprises with next-generation network and AI solutions
            </p>
            <div className="flex space-x-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:bg-white hover:text-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:bg-white hover:text-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:bg-white hover:text-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:bg-white hover:text-teal-600 transition-all cursor-pointer"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-teal-50 hover:text-white hover:translate-x-1 transition-all cursor-pointer inline-block text-sm"
                >
                  Network Solutions
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('solutions')}
                  className="text-teal-50 hover:text-white hover:translate-x-1 transition-all cursor-pointer inline-block text-sm"
                >
                  Cloud Consulting
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-teal-50 hover:text-white hover:translate-x-1 transition-all cursor-pointer inline-block text-sm"
                >
                  Automation Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('training')}
                  className="text-teal-50 hover:text-white hover:translate-x-1 transition-all cursor-pointer inline-block text-sm"
                >
                  Training Programs
                </button>
              </li>
            </ul>
          </div>

          {/* Training Column */}
          <div>
            <h4 className="text-lg font-bold mb-4">Training</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('training')}
                  className="text-teal-50 hover:text-white hover:translate-x-1 transition-all cursor-pointer inline-block text-sm"
                >
                  AI/ML Fundamentals
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('training')}
                  className="text-teal-50 hover:text-white hover:translate-x-1 transition-all cursor-pointer inline-block text-sm"
                >
                  Gen-AI & RAG
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('training')}
                  className="text-teal-50 hover:text-white hover:translate-x-1 transition-all cursor-pointer inline-block text-sm"
                >
                  Agentic-AI
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-teal-50 hover:text-white hover:translate-x-1 transition-all cursor-pointer inline-block text-sm"
                >
                  Custom Projects
                </button>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-lg font-bold mb-4">Stay Updated</h4>
            <p className="text-teal-50 text-sm mb-4">
              Get weekly insights on network innovation and AI trends
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/30 rounded-l-lg text-white placeholder-teal-200 focus:outline-none focus:bg-white/20 text-sm"
              />
              <button className="px-4 py-3 bg-white text-teal-600 rounded-r-lg hover:bg-teal-50 transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
            <p className="text-teal-100 text-xs mt-3">
              Weekly insights on network innovation
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-teal-50">
            <div className="mb-4 md:mb-0">
              © 2024 IT Services. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <span>•</span>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
              <span>•</span>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
